import { gql, useMutation } from '@apollo/client'

const MUTATION_USER_DRIVERS_LICENSE_CATEGORY = gql`
  mutation UserDriversLicenseCategoryApprove(
    $input: UserDriversLicenseCategoryApproveInput!
  ) {
    userDriversLicenseCategoryApprove(input: $input) {
      updatedCount
    }
  }
`

export interface MutationUserDriversLicenseCategoryInput {
  input: {
    userId: number
  }
}

export interface MutationUserDriversLicenseCategoryPayload {
  userDriverLicenseCategory: {
    updatedCount: number
  }
}

const useUserDriversLicenseCategoryMutation = () => {
  return useMutation<
    {
      userDriversLicenseCategoryApprove: MutationUserDriversLicenseCategoryPayload
    },
    MutationUserDriversLicenseCategoryInput
  >(MUTATION_USER_DRIVERS_LICENSE_CATEGORY)
}

export default useUserDriversLicenseCategoryMutation
